import React, { PureComponent, Fragment } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

/**
 * region for styles*/
import { menuBulkActionsStyle } from '../common/style/menuBulkActionsStyle'

class MenuBulkActions extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl : null
        }
    }

    handleClick(event) {
        this.setState({ anchorEl : event.currentTarget });
    };

    handleClose(option) {
        this.setState({ anchorEl: null });
        this.props.callBackMenuItem(option);
    };

    render() {

        const { anchorEl } = this.state;
        const { options, classes } = this.props;

        return (
            <Fragment>
                <IconButton
                    className={classes.button}
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={this.handleClick.bind(this)}>
                    <MoreHorizIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose.bind(this)}>
                    {
                        options.map(option => {
                            return (
                                <MenuItem key={option.key} onClick={this.handleClose.bind(this,option)}>
                                    {option.name}
                                </MenuItem>
                            )
                        })
                    }
                </Menu>
            </Fragment>
        );
    }

}

export default withStyles(menuBulkActionsStyle)(MenuBulkActions);